import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';

const DefinedVsUndefinedChart = ({ data, branches = [], loading }) => {
    
    const getBranchName = (branchId) => {
        const branch = branches.find(b => b.id === branchId);
        return branch ? branch.name : `Sucursal ${branchId}`;
    };

    const chartData = data.map(entry => ({
        name: getBranchName(entry.branchId),
        Definidos: entry.defined,
        Indefinidos: entry.undefined,
    }));

    return (
        <Paper elevation={2} sx={{ p: 2, height: 340 }}>
            <Typography variant="subtitle1" gutterBottom>
                Productos definidos vs indefinidos
            </Typography>
            {loading ? (
                <Skeleton variant="rectangular" height={300} />
            ) : (
                <ResponsiveContainer width="100%" height={300}>
                <BarChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Definidos" stackId="a" fill="#4caf50" />
                    <Bar dataKey="Indefinidos" stackId="a" fill="#ef5350" />
                </BarChart>
                </ResponsiveContainer>
            )}
        </Paper>
    );
};

export default DefinedVsUndefinedChart;
